module.exports = __webpack_public_path__ + "img/gh-36330m-2.prt.9d98ba91.jpg";